import { isUfeEnvProduction } from '@ufe/shared/constants/env';
import printTimestamp from '@ufe/shared/utils/timestamp';

const logError = (error = {}, additionalInformation = { source: 'Unknown' }) => {
    const { isNodeRender, pagePath: path, renderQueryParams: queryParams } = Sephora;
    const { message = '', name = '', stack = '' } = error;

    if (isNodeRender) {
        if (!isUfeEnvProduction && Sephora?.serverErrors && Array.isArray(Sephora.serverErrors)) {
            Sephora.serverErrors.push({
                message,
                name,
                path,
                queryParams,
                stack,
                ...additionalInformation
            });
        }
    }

    const logEntry = `${printTimestamp()} [URL: ${queryParams?.urlPath ?? ''}] [template: ${path}] [${additionalInformation.source}] [component: ${additionalInformation.compClass?.componentName}] [functional: ${additionalInformation.compClass?.isFunctional}] [recieved props: ${!!additionalInformation.props}] ${stack}`;

    // eslint-disable-next-line no-console
    console.error(logEntry);
};

export default logError;
